import React from "react"
import ZdqConnectorStatus from "../../components/ZdqConnectorStatus"
import { GCP_POSTGRES } from "../../Constants"

function ZdqGcpPostgresConnectorStatus() {
    return <ZdqConnectorStatus vendor={GCP_POSTGRES}></ZdqConnectorStatus>
}

export default ZdqGcpPostgresConnectorStatus